import script from "./side-nav-outer-toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=ca48608c&lang=scss"

const __exports__ = script;

export default __exports__